import Ledger from "@/views/accountants/Ledger"
import LedgerCategoriesTable from "@/components/accountants/LedgerCategoriesTable"
import Dashboard from "@/views/accountants/Dashboard"
import Customers from "@/views/accountants/Customers"
import PendingInvitations from "@/views/accountants/PendingInvitations"
// import CustomerOverview from "@/components/accountants/CustomerOverview"
import ControlPanel from "@/views/accountants/ControlPanel"
import BalanceSheet from "@/views/gekko/BalanceSheet"
import CostTypesSettings from "@/views/settings/CostTypesSettings"
import DownloadData from "@/views/settings/DownloadData"
import TaxreportList from "@/views/gekko/TaxreportList"
import Taxreport from "@/views/gekko/Taxreport"
import ForeignVATList from "@/views/gekko/ForeignVATList"
import ForeignVAT from "@/views/gekko/ForeignVAT"
import FinancialReporting from "@/views/gekko/FinancialReporting"
import AddEditInvestmentItem from "@/components/balance_sheet/AddEditItem";

import ControlPanelInvoiceSettings from "@/views/settings/InvoiceSettings";

import Costs from "@/views/gekko/Costs"
import Invoices from "@/views/gekko/Invoices"
import Bank from "@/views/gekko/Bank"
import EditCost from "@/components/costs/EditCost"
import invoicesControlPanelRoutes from "./invoices/"

import Communication from '@/views/accountants/Communication.vue'

import TaxReturn from "@/components/accountants/tax_return/TaxReturn.vue";
import Files from "@/views/gekko/Files";
import BankConnection from "@/views/accountants/BankConnection";
import CompanySettings from "@/views/settings/CompanySettings";
import ChangePassword from '@/views/settings/ChangePassword'
import ProfileSettings from "@/views/settings/ProfileSettings";
import AccountantSubscriptions from "@/views/settings/AccountantSubscriptions";
import PaymentComplete from "@/views/settings/PaymentComplete";

const routes = [
  { path: '/:language/accountants/dashboard/', name: 'AccountantsDashboard', component: Dashboard, meta: { title: 'Dashboard' }, pathToRegexpOptions: { strict: true } },
  
  // Clients
  { path: '/:language/accountants/clients/', name: 'Clients', component: Customers, meta: { title: 'Clients' }, pathToRegexpOptions: { strict: true } },
  { path: '/:language/accountants/pending-invitations/', name: 'PendingInvitations', component: PendingInvitations, meta: { title: 'Pending Invitations' }, pathToRegexpOptions: { strict: true } },
  
  {
    path: '/:language/accountants/ledger/', name: 'Ledger', component: Ledger, meta: { title: 'Ledger' }, pathToRegexpOptions: { strict: true }, children: [
      { path: '', component: CostTypesSettings, name: 'Ledger', meta: { title: 'Ledger' } },
      { path: 'ledger-categories', component: LedgerCategoriesTable, name: 'LedgerCategoriesTable', meta: { title: 'Ledger Categories' } }
    ]
  },
  { path: '/:language/accountants/control-panel/:customerId/summary/', name: 'ControlPanelSummary', component: ControlPanel, meta: { title: 'Summary' }, pathToRegexpOptions: { strict: true } },
  { path: '/:language/accountants/control-panel/:customerId/invoice-settings/', component: ControlPanelInvoiceSettings, name: 'ControlPanelInvoiceSettings', meta: { title: 'Invoice Settings' }, pathToRegexpOptions: { strict: true } },
  {
    path: '/:language/accountants/control-panel/:customerId/invoices/', name: 'ControlPanelInvoices', component: Invoices, meta: { title: 'Invoices' }, pathToRegexpOptions: { strict: true }, children: [
      ...invoicesControlPanelRoutes
    ]
  },
  {
    path: '/:language/accountants/control-panel/:customerId/costs/', name: 'ControlPanelCosts', component: Costs, meta: { title: 'Costs' }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'edit/:costId/', component: EditCost, name: 'ControlPanelEditCost', meta: { title: 'Edit costs', masterModal: 'edit' } },
      { path: 'add/', component: EditCost, name: 'ControlPanelAddCost', meta: { title: 'Add cost' } }
    ]
  },
  {
    path: '/:language/accountants/control-panel/:customerId/bank/', name: 'ControlPanelBank', component: Bank, meta: { title: 'Bank' }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'transaction/:transaction_id/', component: Bank, name: 'ControlPanelBankTransaction', meta: { title: 'Bank' }, pathToRegexpOptions: { strict: true } },
    ]
  },

  // Vat
  {
    path: "/:language/accountants/control-panel/:customerId/vat/", component: TaxreportList, name: "ControlPanelVAT", meta: { title: 'VAT reports' }, pathToRegexpOptions: { strict: true }, children: [
      { path: "create/", component: Taxreport, name: "ControlPanelCreateVAT", meta: { title: 'Create VAT report' } },
      { path: "view/:id/", component: Taxreport, name: "ControlPanelViewVAT", meta: { title: 'View VAT report' } },
    ]
  },

  {
    path: "/:language/accountants/control-panel/:customerId/foreign-vat/", component: ForeignVATList, name: "ControlPanelForeignVAT", meta: { title: 'Foreign VAT reports' }, pathToRegexpOptions: { strict: true }, children: [
      { path: "create/", component: ForeignVAT, name: "ControlPanelCreateForeignVAT", meta: { title: 'Create foreign VAT report' } },
      { path: "view/:id/", component: ForeignVAT, name: "ControlPanelViewForeignVAT", meta: { title: 'View foreign VAT report' } },
    ]
  },
  { path: "/:language/accountants/control-panel/:customerId/foreign-vat/sample/", component: ForeignVAT, name: "ControlPanelForeignVATSample", meta: { title: 'Foreign VAT Report Sample' } },

  // Investments
  { path: '/:language/accountants/control-panel/:customerId/investments/', name: 'ControlPanelInvestments', component: BalanceSheet, meta: { title: 'Balance Sheet Investments' }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'costtypes/', component: CostTypesSettings, name: 'ControlPanelInvestmentsCostTypes', meta: { title: 'Cost types' } },
      { path: 'editcost/:costId', name: 'ControlPanelBalanceSheetEditCost', meta: { title: 'Edit costs', masterModal: 'edit' } },
      { path: 'additem/', component: AddEditInvestmentItem, name: 'ControlPanelAddInvestmentItem', meta: { title: 'Add item' } },
      { path: 'edititem/:investmentId', component: AddEditInvestmentItem, name: 'ControlPanelEditInvestmentItem', meta: { title: 'Edit item' } }
  ] },

  { path: '/:language/accountants/control-panel/:customerId/financial-statements/', name: 'ControlPanelFinancialStatements', component: FinancialReporting, meta: { title: 'Financial Statements' }, pathToRegexpOptions: { strict: true } },
  { path: '/:language/accountants/control-panel/:customerId/costtypes/', name: 'ControlPanelCostTypes', component: CostTypesSettings, meta: { title: 'Cost types' }, pathToRegexpOptions: { strict: true } },
  { path: '/:language/accountants/control-panel/:customerId/tax-return/', name: 'ControlPanelTaxReturn', component: TaxReturn, meta: { title: 'Tax return' }, pathToRegexpOptions: { strict: true } },
  { path: '/:language/accountants/control-panel/:customerId/export/', name: 'ControlPanelExport', component: DownloadData, meta: { title: 'Download your data' }, pathToRegexpOptions: { strict: true } },
  {
    path: '/:language/accountants/control-panel/:customerId/files/', name: 'ControlPanelFiles', component: Files, meta: { title: 'Files' }, pathToRegexpOptions: { strict: true }, children: [
      { path: ':id/', name: 'ControlPanelFileDetails', component: Files, meta: { title: 'File Details', showModal: true } }
    ]
  },
  { path: "/:language/accountants/control-panel/:customerId/bank-connection/", name: "BankConnectionAccountant", component: BankConnection, meta: { title: 'Bank Connection' } },

  // Communication
  { path: '/:language/accountants/communication/:filter_by/', name: 'Communication', component: Communication, meta: { title: 'Communication', showComposeModal: false, showDetailModal: false }, pathToRegexpOptions: { strict: true } },
  { path: '/:language/accountants/communication/:filter_by/create/', name: 'CommunicationCreate', component: Communication, meta: { title: 'Compose communication', showComposeModal: true, showDetailModal: false }, pathToRegexpOptions: { strict: true } },
  { path: '/:language/accountants/communication/:filter_by/detail/:communication_id/', name: 'CommunicationDetail', component: Communication, meta: { title: 'Communication details', showComposeModal: false, showDetailModal: true }, pathToRegexpOptions: { strict: true } },
  { path: '/:language/accountants/communication/:filter_by/edit/:communication_id/', name: 'CommunicationEdit', component: Communication, meta: { title: 'Compose communication', showComposeModal: true, showDetailModal: false }, pathToRegexpOptions: { strict: true } },

  // Settings
  { path: "/:language/accountants/settings/companies", name: "AccountantCompanySettings", component: CompanySettings, meta: { title: 'Change your company details' } },
  { path: "/:language/accountants/settings/profile", name: "AccountantProfileSettings", component: ProfileSettings, meta: { title: 'My Personal Profile' } },
  { path: "/:language/accountants/settings/change/password", name: "AccountantProfileChangePassword", component: ChangePassword, meta: { title: 'Change my password' } },
  { path: "/:language/accountants/settings/subscriptions", name: "AccountantSubscriptions", component: AccountantSubscriptions, meta: { title: 'Manage your subscription' } },
  { path: "/:language/accountants/settings/subscriptions/payment-complete/", name: "PaymentComplete", component: PaymentComplete, meta: { title: 'Manage your subscription' } },

]

export default routes